<template>
  <div class="sjxqy">
    <mt-header title="商机详情">
      <span slot="left" @click="()=>this.$router.back()">
        <i class="iconfont icon-left"></i>
        Return
      </span>
    </mt-header>
    <div class="detailContent">
      <div>
        <!-- content -->
        <div class="comments">
          <!-- 用户信息 -->
          <div class="comUser">
            <div class="userImg">
              <img src="https://picsum.photos/id/98/200/200" alt="" />
            </div>
            <div class="userInfo"> 
              <h6>
                name
                <span>职位</span>
                <span v-if="true" class="approve">认证展商</span>
              </h6>
              <p>*******有限公司</p>
            </div>
          </div>
          <!-- 简介 -->
          <p class="comIntro">
            介绍是经过加工处理的、有一定含义的、并能对人类客观行为产生影响或对决策有价值的数据。
          </p>
          <!-- 定位 -->
          <div class="place" v-if="true">
            <i class="iconfont icon-dingwei"></i><span>北京通州</span>
          </div>
          <!-- 商品图片 -->
          <div class="goodsImg" v-if="true">
            <div>
              <img src="https://picsum.photos/id/977/200/200" alt="" />
            </div>
            <div>
              <img src="https://picsum.photos/id/977/200/200" alt="" />
            </div>
            <div>
              <img src="https://picsum.photos/id/977/200/200" alt="" />
            </div>
          </div>
          <div class="comAction">
            <span class="time">
              Time2020-07-10 16:48:53
            </span>
            <div class="action">
              <span>
                <i class="iconfont icon-yanjing"></i>
                481
              </span>
            </div>
          </div>
        </div>
        <div class="message">
          <h4>评论<span>{{num}}</span></h4>
          <ul class="messageUL" v-if="list">
            <li class="messageLI" v-for="(item,i) in list" :key="'C'+i">
              <p class="p1">
                <img src="https://picsum.photos/id/811/80/80" alt="" />
                <span>站站长</span>
              </p>
              <p class="p2">
                这是什么产品
              </p>
              <div class="comAction">
                <span class="time">
                  tIME2020-07-10 16:48:53
                </span>
                <div class="action">
                  <span>
                    <i class="iconfont icon-liuyan"></i>
                    0
                  </span>
                  <span>
                    <i class="iconfont icon-yanjing"></i>
                    481
                  </span>
                </div>
              </div>
            </li>
          </ul>
          <p v-else>还没有消息哦，马上<span @click="popupVisible=true;textInput=''">评论</span>一下吧！</p>
        </div>

      </div>
    </div>
    <ul class="footer">
      <li @click="like1=!like1; $router.push('/user/credential/'+id)">
        <i class="iconfont icon-iconfontzhizuobiaozhun0258"></i>
        <span>联系</span>
      </li>
      <li @click="like3=!like3;popupVisible=!popupVisible;textInput=''">
        <i class="iconfont icon-liuyan"></i>
        <span>评论</span>
      </li>
      
    </ul>
    <mt-popup
      v-model="popupVisible"
      position="bottom">
      <textarea class="textInput" maxlength="200" v-model="textInput" placeholder="请输入评论"></textarea>
      <p class="group">
        <span>{{textInput.length}}/200</span>
        <button @click="addMessage">提交评论</button>
      </p>
    </mt-popup>
  </div>
</template>

<script>
import { Header, Popup, } from 'mint-ui';
import "mint-ui/lib/header/style.css"
import "mint-ui/lib/popup/style.css"
export default {
  components:{
    'mt-header':Header,
    'mt-popup':Popup
  },
  data () {
    return {
      popupVisible:false,
      textInput:"",
      like1:true,
      like3:true,
      list:[1,2,3,4,5,6,7,8,9,10],
      num:0,
      id:0
    }
  },
  methods:{
    addMessage(){
      // let text = this.textInput
      // console.log(text);
      
      // 发请求

      // 清除内容
      this.popupVisible=false
      this.textInput = ""
    }
  }
}
</script>

<style scoped>
  .sjxqy{
    height: 100%;  
    background-color: #f3f3f3;  
  }
  .mint-header{
    height: 40px;
    background-color: #008baf;
    position: relative;
    z-index: 10;
  }
  .detailContent{
    height: calc(100vh - 90px);
    overflow-y: auto;
  }
  .comments{
    width: 100%;
    padding: 25px 10px 10px;
    box-sizing: border-box;
    margin-bottom: 25px;
    overflow: hidden;
    background-color: white;
  }
  .comUser{
    width: 100%;
    display: flex;
    margin-bottom: 15px;
  }
  .userImg{
    width: 60px;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 10px;
  }
  .userInfo{
    width: 285px;
  }
  .userInfo h6{
    font-size: 18px;
    margin-bottom: 8px;
  }
  .userInfo span{
    margin-left: 5px;
    font-size: 12px;
    color: #808080;
  }
  .userInfo .approve{
    float: right;
    margin-top: 5px;
    margin-right: 25px;
    font-size: 14px;
    padding: 0 5px;
    background-color: #b2dce7;
    border-radius: 15px;
    line-height: 25px;
    color: #008baf;
  }
  .userInfo p{
    color: #808080;
  }
  .comIntro{
    color: #808080;
    line-height: 18px;
    margin-bottom: 15px;
  }
  .place{
    color: #008baf;
    vertical-align: middle;
    height: 23px;
  }
  .place i{
    vertical-align: middle;
    font-size: 18px;
  }
  .place span{
    vertical-align: middle;
  }
  /* goodsImg */
  .goodsImg{
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding-bottom: 20px;
    border-bottom: 1px solid #cccccc;
  }
  .goodsImg>div{
    width: 111px;
    height: 111px;
  }
  /* footer */
  .comAction{
    padding-top: 10px;
    display: flex;
    justify-content: space-between;
    color: #808080;
  }
  .comAction .action span{
    margin-right: 10px;
    vertical-align: middle;
  }
  .comAction i{
    vertical-align: middle;
  }
  .message{
    min-height: 150px;
    background-color: white;
    box-shadow: 0 5px 5px 5px rgba(0, 0, 0, .1);
  }
  .message h4{
    font-size: 16px;
    padding: 10px;
    font-weight: 100;
    border-bottom: 1px solid #eeeeee;
  }
  .message h4 span{
    margin-left: 5px;
  }
  .messageUL{
    padding: 0 10px;
    /* margin-bottom: 20px; */
  }
  .messageLI{
    padding-top: 25px;
    padding-bottom: 10px;
    border-top: 1px dashed;
  }
  .messageLI:first-child{
    border-top: none;
  }
  .messageLI .p1 img{
    width: 32px;
    vertical-align: middle;
    border-radius: 50%;
    margin-right: 5px;
  }
  .messageLI .p1 span{
    font-size: 15px;
    vertical-align: middle;
  }
  .messageLI .p2{
    font-size: 13px;
    color: #808080;
    padding: 10px;
  }
  .message >p{
    padding: 25px 10px;
    text-align: center;
    font-size: 13px;
  }
  .message >p span{
    color: #008baf;
    
  }
  
  


  .footer{
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 50px;
    text-align: center;
    display: flex;
    justify-content: space-around;
    box-shadow: 0 5px 5px 5px rgba(0, 0, 0, .3) ;
  }
  .footer li{
    padding-top: 3px;
    list-style: none;
    width: 50%;
    border-left: 1px solid white;
    background-color: #f3f3f3;
  }
  .footer li :first-child{
    border: none;
  }
  .footer li div{
    width: 27px;
    margin: 0 auto;
  }
  .footer li i{
    margin: 0 auto;
    font-size: 27px;
    display: block;
    color: #8b8a8a;
  }
  .footer li .hue{
    color: #ff840c;
  }

  .mint-popup-bottom{
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    background-color: #f3f3f3;
  }
  .textInput{
    width: 100%;
    height: 100px;
    border: none;
    background-color: white;
    outline: none;
    font-size: 13px;
    resize: none;
    padding: 10px;
    box-sizing: border-box;
  }
  .group{
    padding-top: 10px;
    display: flex;
    justify-content: space-between;
  }
  .group span{
    color: #808080;
    vertical-align: middle;
  }
  .group button{
    color: white;
    background-color: #008baf;
    border: none;
    padding: 5px 15px;
    border-radius: 3px;
    outline: none;
  }
</style>